export default "__VITE_ASSET__C$cdH8uv__"